import React from "react";
import { IconButton } from "@mui/material";
import { ValueChangedEvent } from "@shared/type/CommonType";
import SnHeader from "@shared/components/SnHeader";
interface DesignerSnTabHeaderProps {
  onBtnAddClick?: (id: string) => void;
  onBtnDeleteClick?: (id: string) => void;
  body?: React.ReactNode;
  headerInfo?: any;
  onHeaderValueChanged?: (
    event: ValueChangedEvent
  ) => Record<string, any> | void;
  onBtnEtcClick?: (sender: string) => void;
}

export function DesignerSnTabHeader({
  onBtnAddClick,
  onBtnDeleteClick,
  body,
  headerInfo,
  onHeaderValueChanged,
  onBtnEtcClick,
}: DesignerSnTabHeaderProps) {
  return (
    <div>
      <div className="flex justify-end items-center">
        <div className="ml-2">{body}</div>
        <SnHeader
          headerInfo={headerInfo}
          onHeaderValueChanged={onHeaderValueChanged}
          onButtonClick={onBtnEtcClick}
        />
        {onBtnAddClick != null && (
          <div className="ml-2">
            <IconButton
              onClick={() => {
                onBtnAddClick != null && onBtnAddClick("addRow");
              }}
              sx={{
                backgroundImage: "url(/images/new_off.svg)", // 기본 상태 이미지
                backgroundSize: "cover", // 이미지 크기 맞추기
                width: 30, // 버튼 크기
                height: 30, // 버튼 크기
                "&:hover": {
                  backgroundImage: "url(/images/new_on.svg)", // hover 시 이미지
                  transform: "scale(1.2)", // hover 시 크기 확대
                  transition: "all 0.3s ease", // 부드러운 애니메이션
                },
              }}
            ></IconButton>
          </div>
        )}
        {onBtnDeleteClick != null && (
          <div className="ml-5 mr-4">
            <IconButton
              onClick={() => {
                onBtnDeleteClick != null && onBtnDeleteClick("deleteRow");
              }}
              sx={{
                backgroundImage: "url(/images/delete_off.svg)", // 기본 상태 이미지
                backgroundSize: "cover", // 이미지 크기 맞추기
                width: 25, // 버튼 크기
                height: 25, // 버튼 크기
                "&:hover": {
                  backgroundImage: "url(/images/delete_on.svg)", // hover 시 이미지
                  transform: "scale(1.2)", // hover 시 크기 확대
                  transition: "all 0.3s ease", // 부드러운 애니메이션
                },
              }}
            ></IconButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(DesignerSnTabHeader);
